import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { AnimalSelection, animalSelectionDisplayName } from '@tcc-mono/vandijk/shared/data-access/models';
import { AnimalSelectionRepository } from '@tcc-mono/vandijk/shared/data-access/state';
import { filter, map, Observable, take } from 'rxjs';
import { ANIMAL_SELECTION_CONFIG, AnimalSelectionConfig } from '../../../animal-selection-shell/src';

@Component({
  selector: 'tcc-mono-animal-selection',
  templateUrl: './animal-selection.component.html',
  styleUrls: ['./animal-selection.component.scss']
})
export class AnimalSelectionComponent implements OnInit {
  private readonly _repo = inject(AnimalSelectionRepository);
  private readonly _route = inject(ActivatedRoute);
  private readonly _router = inject(Router);
  private readonly _destroyRef = inject(DestroyRef);
  private readonly _config: AnimalSelectionConfig = inject(ANIMAL_SELECTION_CONFIG);

  public readonly selection$: Observable<AnimalSelection> = this._repo.activeEntity$;
  public readonly pageTitle$: Observable<string> = this.selection$.pipe(
    filter((selection): selection is AnimalSelection => !!selection),
    map((selection) => animalSelectionDisplayName(selection))
  );

  public animalsTabLoading = false;
  public readonly skeletonRows = [0, 1, 2, 3, 4, 5, 6];
  public isApp: boolean;

  private readonly _selectionId: string = this._route.parent.snapshot.params['id'];

  public ngOnInit(): void {
    this.isApp = this._config.source === 'app';
    const selectionId = Number(this._selectionId);

    this._repo.getEntity(selectionId, true, true).pipe(take(1)).subscribe();
    this._repo.getSelectionMarkColorsForSelection(selectionId).pipe(take(1)).subscribe();
    // Dieren pagina 1 alvast onderwater laden (zoals gegevens uit store)
    this._repo.getSelectionWithAnimals(selectionId, true, false).pipe(take(1)).subscribe();
    this._watchAnimalsTabNavigation();
  }

  private _watchAnimalsTabNavigation(): void {
    this._router.events
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe((event) => {
        if (event instanceof NavigationStart) {
          if (this._isAnimalsTabUrl(event.url)) {
            const selectionId = Number(this._selectionId);
            this.animalsTabLoading = !this._repo.hasCachedSelectionAnimals(selectionId);
          }
          return;
        }

        if (
          event instanceof NavigationEnd ||
          event instanceof NavigationCancel ||
          event instanceof NavigationError
        ) {
          this.animalsTabLoading = false;
        }
      });
  }

  private _isAnimalsTabUrl(url: string): boolean {
    return /\/animals(?:[/?#]|$)/.test(url);
  }
}
